module.exports = __webpack_public_path__ + "media/1.e2755d57.mp3";